import type { AuthMeResponse } from '@zrsystem/contracts';

import type { PlaceSummary } from '@/app/workspace/types.js';

export function formatPlaceContextLabel(place: PlaceSummary | null): string {
  if (place === null) {
    return 'Selecionar unidade';
  }

  return place.name;
}

export function getUserInitials(user: AuthMeResponse | null): string {
  const email = user?.email?.trim();
  if (!email) {
    return '?';
  }

  const local = email.split('@')[0] ?? email;
  const parts = local.split(/[.\-_]/).filter(Boolean);

  const first = parts[0];
  const second = parts[1];
  if (first !== undefined && second !== undefined) {
    return `${first[0] ?? ''}${second[0] ?? ''}`.toUpperCase();
  }

  return local.slice(0, 2).toUpperCase();
}

export function isNavItemActive(
  pathname: string,
  item: { path?: string; matchPrefix?: string },
): boolean {
  if (item.path === undefined) {
    return false;
  }

  const prefix = item.matchPrefix ?? item.path;

  if (prefix === '/') {
    return pathname === '/';
  }

  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}
